import { ComponentType } from 'react';

import { ICreateWidget } from './models';
import { hoist, createWrapper } from './helpers';

/**
 * Функция hoc, для создания виджета, принимает объект зависимостей
 * и возвращает компонент с внедренными зависимостями
 */
export const createWidget: ICreateWidget =
    <T, U extends T>(dependencies?: T) =>
    (Widget: ComponentType<U>) =>
        hoist(createWrapper(Widget, dependencies), Widget);
